import "swiper/swiper-bundle.css";

import { Autoplay, Navigation, Pagination } from "swiper/modules";

import Swiper from "swiper";

Array.from(document.querySelectorAll("section.logo-slider .swiper")).map(
	(hero) => {
		const swiper = new Swiper(hero, {
			slidesPerView: 1.5,
			spaceBetween: 24,
			modules: [Autoplay, Pagination, Navigation],
			centeredSlides: true,
			autoplay: {
				delay: 3500,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			loop: true,
			breakpoints: {
				768: {
					slidesPerView: 4,
					spaceBetween: 40,
				},
				1200: {
					slidesPerView: 6.5,
					spaceBetween: 72,
				},
			},
		});
	}
);
